const o="div";export{o as CardDefaultAsType};
